import React from 'react';
import HeadingSection from '../components/HomepageComponents/HeadingSection';
import ProductSection from '../components/HomepageComponents/ProductSection';    
import JoinSection from '../components/HomepageComponents/JoinSection';                                                               
import '../components/styles.css';
import NavbarComponent from '../components/HomepageComponents/NavbarComponent';



export default function HomePage() {

    return (
            <div className = "homepage-content">
                <NavbarComponent/>
                <HeadingSection/>
                <ProductSection 
                    desctitle = "Revolutionary AI Writing Assistant"
                    description = "Say goodbye to writer’s block. PenPal.ai is designed to drive focus, spark creativity and inspire you to write"
                    imgURL = {require("../components/assets/images/writingimage.jpg")}
                    direction = "row"
                />
                <ProductSection 
                    desctitle = "Unleash your full potential"
                    description = "Say goodbye to untapped creativity and break free from the constraints of traditional writing with Penpal.ai's innovative features."
                    imgURL = {require("../components/assets/images/writingimage.jpg")}
                    direction = "row-reverse"
                />
                <JoinSection/>

                
            </div>
    )
    
}